<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="参数名称" prop="configName">
        <a-input disabled v-model="form.configName" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数分组" prop="configGroup">
        <a-input disabled v-model="form.configGroup" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数键名" prop="configKey">
        <a-input disabled v-model="form.configKey" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数类型" prop="configType">
        <a-radio-group disabled  v-model="form.configType" button-style="solid">
          <a-radio-button v-for="(d, index) in  configTypeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <template v-if="form.configKey == 'sendVipDays' && form.configGroup == 'sendVipDays'">
        <a-form-model-item label="参数键值" prop="configValue">
          <a-input v-model="form.configValue" placeholder="请输入" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValue" placeholder="请输入" v-if="form.configType=== '2' " />
          <editor editorValue="configValue" v-model="form.configValue" v-if="form.configType=== '3' " />

          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValue"
            :showUploadList="false"
            :customRequest="handleChange"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValue" :src="form.configValue" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
      </template>


      <template v-else>
        <a-form-model-item label="繁体中文参数键值" prop="configValue">
          <a-input v-model="form.configValue" placeholder="请输入" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValue" placeholder="请输入" v-if="form.configType=== '2' " />
          <editor editorValue="configValue" v-model="form.configValue" v-if="form.configType=== '3' " />

          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValue"
            :showUploadList="false"
            :customRequest="handleChange"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValue" :src="form.configValue" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="英文参数键值" prop="configValueEn">
          <a-input v-model="form.configValueEn" placeholder="请输入" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValueEn" placeholder="请输入" v-if="form.configType=== '2' " />
          <editor editorValue="configValueEn"  v-model="form.configValueEn" v-if="form.configType=== '3' " />
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValueEn"
            :showUploadList="false"
            :customRequest="handleChangeEn"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValueEn" :src="form.configValueEn" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoadingEn ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="简体中文参数键值" prop="configValueCn">
          <a-input v-model="form.configValueCn" placeholder="请输入" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValueCn" placeholder="请输入" v-if="form.configType=== '2' " />
          <editor editorValue="configValueCn"  v-model="form.configValueCn" v-if="form.configType=== '3' " />
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValueCn"
            :showUploadList="false"
            :customRequest="handleChangeCn"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValueCn" :src="form.configValueCn" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoadingCn ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="法语参数键值" prop="configValueBm">
          <a-input v-model="form.configValueBm" placeholder="请输入" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValueBm" placeholder="请输入" v-if="form.configType=== '2' " />
          <editor editorValue="configValueBm"  v-model="form.configValueBm" v-if="form.configType=== '3' " />
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValueBm"
            :showUploadList="false"
            :customRequest="handleChangeBm"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValueBm" :src="form.configValueBm" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoadingBm ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="日语参数键值" prop="configValueIn">
          <a-input v-model="form.configValueIn" placeholder="请输入" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValueIn" placeholder="请输入" v-if="form.configType=== '2' " />
          <editor editorValue="configValueIn"  v-model="form.configValueIn" v-if="form.configType=== '3' " />
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValueIn"
            :showUploadList="false"
            :customRequest="handleChangeIn"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValueIn" :src="form.configValueIn" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoadingIn ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="阿拉伯语参数键值" prop="configValueAb">
          <a-input v-model="form.configValueAb" placeholder="请输入" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValueAb" placeholder="请输入" v-if="form.configType=== '2' " />
          <editor editorValue="configValueAb"  v-model="form.configValueAb" v-if="form.configType=== '3' " />
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValueAb"
            :showUploadList="false"
            :customRequest="handleChangeAb"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValueAb" :src="form.configValueAb" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoadingAb ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="越南语参数键值" prop="configValueVi">
          <a-input v-model="form.configValueVi" placeholder="请输入" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValueVi" placeholder="请输入" v-if="form.configType=== '2' " />
          <editor editorValue="configValueVi"  v-model="form.configValueVi" v-if="form.configType=== '3' " />
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValueVi"
            :showUploadList="false"
            :customRequest="handleChangeVi"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValueVi" :src="form.configValueVi" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoadingVi ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="韩语参数键值" prop="configValueKo">
          <a-input v-model="form.configValueKo" placeholder="请输入" v-if="form.configType=== '1' " />
          <a-textarea v-model="form.configValueKo" placeholder="请输入" v-if="form.configType=== '2' " />
          <editor editorValue="configValueKo"  v-model="form.configValueKo" v-if="form.configType=== '3' " />
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.configValueKo"
            :showUploadList="false"
            :customRequest="handleChangeKo"
            v-if="form.configType=== '4' "
          >
            <img v-if="form.configValueKo" :src="form.configValueKo" alt="logo"
                 style="height:50px;width:50px"/>
            <div v-else>
              <a-icon :type="uploadLoadingKo ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
      </template>





<!--      <a-form-model-item label="系统内置" prop="configSystem">-->
<!--        <a-radio-group v-model="form.configSystem" button-style="solid">-->
<!--          <a-radio-button v-for="(d, index) in typeOptions" :key="index" :value="d.value">-->
<!--            {{ d.label }}-->
<!--          </a-radio-button>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark">-->
<!--        <a-input v-model="form.remark" placeholder="请输入备注" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { getConfig, addConfig, updateConfig } from '@/api/system/config'
import Editor from '@/components/Editor'
import UploadFileToVOD from "@/api/vod";
import Template from "@/views/sms/template";
export default {
  name: 'CreateForm',
  props: {
    typeOptions: {
      type: Array,
      required: true
    }
  },
  components: {
    Template,
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      uploadLoading:false,
      uploadLoadingEn:false,
      uploadLoadingCn:false,
      uploadLoadingBm:false,
      uploadLoadingIn:false,
      uploadLoadingAb:false,
      uploadLoadingVi:false,
      uploadLoadingKo:false,
      configTypeOptions: [{"value":"1","label":"输入框"},{"value":"2","label":"文本框"},{"value":"3","label":"富文本"},{"value" : "4" ,"label" :"图片"}],
      // 表单参数
      form: {
        id: undefined,
        configName: undefined,
        configGroup: undefined,
        configKey: undefined,
        configValue: "",
        configValueEn: "",
        configValueCn: "",
        configValueBm: "",
        configValueIn: "",
        configValueAb: "",
        configValueVi: "",
        configValueKo: "",
        iosConfigValue: "",
        iosConfigValueEn: "",
        iosConfigValueCn: "",
        iosConfigValueBm: "",
        iosConfigValueIn: "",
        configType: "1",
        remark: undefined
      },
      open: false,
      rules: {
        configName: [{ required: true, message: '参数名称不能为空' }],
        configGroup: [{ required: true, message: '参数名称不能为空' }],
        configKey: [{ required: true, message: '参数键名不能为空' }],
        configValue: [{ required: true, message: '参数键值不能为空' }],
        configValueEn: [{ required: true, message: '参数键值不能为空' }],
        configValueCn: [{ required: true, message: '参数键值不能为空' }],
        configValueBm: [{ required: true, message: '参数键值不能为空' }],
        configValueIn: [{ required: true, message: '参数键值不能为空' }],
        configValueAb: [{ required: true, message: '参数键值不能为空' }],
        configValueVi: [{ required: true, message: '参数键值不能为空' }],
        configValueKo: [{ required: true, message: '参数键值不能为空' }],
        iosConfigValue: [{ required: true, message: '参数键值不能为空' }],
        iosConfigValueEn: [{ required: true, message: '参数键值不能为空' }],
        iosConfigValueCn: [{ required: true, message: '参数键值不能为空' }],
        iosConfigValueBm: [{ required: true, message: '参数键值不能为空' }],
        iosConfigValueIn: [{ required: true, message: '参数键值不能为空' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    handleChange(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValue = fileName[0];//文件名
          that.uploadLoading = false;
        },
      });
      that.uploadLoading = false;
    },
    handleChangeIn(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueIn = fileName[0];//文件名
          that.uploadLoadingIn= false;
        },
      });
      that.uploadLoadingIn = false;
    },
    handleChangeBm(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueBm = fileName[0];//文件名
          that.uploadLoadingBm = false;
        },
      });
      that.uploadLoadingBm = false;
    },
    handleChangeEn(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueEn = fileName[0];//文件名
          that.uploadLoadingEn = false;
        },
      });
      that.uploadLoadingEn = false;
    },
    handleChangeCn(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueCn = fileName[0];//文件名
          that.uploadLoadingCn = false;
        },
      });
      that.uploadLoadingCn = false;
    },
    handleChangeAb(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueAb = fileName[0];//文件名
          that.uploadLoadingAb = false;
        },
      });
      that.uploadLoadingAb = false;
    },
    handleChangeVi(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueVi = fileName[0];//文件名
          that.uploadLoadingVi = false;
        },
      });
      that.uploadLoadingVi = false;
    },
    handleChangeKo(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueKo = fileName[0];//文件名
          that.uploadLoadingKo = false;
        },
      });
      that.uploadLoadingKo = false;
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: undefined,
        configName: undefined,
        configGroup: undefined,
        configKey: undefined,
        configValue: '',
        configType: "1",
        remark: undefined
      }
    },
     /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.open = true
      this.formTitle = '添加参数'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      const configId = row ? row.id : ids
      getConfig(configId).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改参数'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            updateConfig(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addConfig(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
